// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"bdc77a48","453":"f64c6388","455":"c80f8f1f","977":"069d6fc6"}[chunkId] + ".chunk.js";
};